<template>
<div class="chapter">
<div class="inner_page">
<p class="p4">This book is dedicated to Elizabeth and Lynn, without whose help it would never have been possible. Thanks to Elizabeth for believing in me even when I didn’t believe in myself, and thanks to Lynn for helping me to understand and be calm (okay, more calm) each step of the way through the long publication process. You are both stars to me.</p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?28b0e754